import type { DeliveryCity } from '@c214/shared';
import { useState } from 'react';
import { useDebouncedValue } from '../../hooks/useDebouncedValue';
import { useCities } from '../../hooks/useDelivery';
import { Input } from '../ui/input';

export function CityAutocomplete({
  value,
  onSelect,
}: {
  value: DeliveryCity | null;
  onSelect: (city: DeliveryCity | null) => void;
}) {
  const [query, setQuery] = useState(value?.name ?? '');
  const debouncedQuery = useDebouncedValue(query, 300);
  const { data: cities = [], isFetching } = useCities(debouncedQuery);
  const showList = query.length >= 2 && !value && cities.length > 0;
  const showEmpty = query.length >= 2 && !value && !isFetching && cities.length === 0;

  return (
    <div className="relative">
      <Input
        placeholder="Місто"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          if (value) onSelect(null);
        }}
      />
      {isFetching && query.length >= 2 && (
        <p className="mono-label absolute right-3 top-1/2 -translate-y-1/2">…</p>
      )}
      {showList && (
        <ul className="absolute z-10 mt-1 max-h-56 w-full overflow-y-auto border border-line bg-surface-2">
          {cities.map((city) => (
            <li key={city.ref}>
              <button
                type="button"
                onClick={() => {
                  onSelect(city);
                  setQuery(city.name);
                }}
                className="block w-full border-none bg-transparent px-4 py-2 text-left text-[14px] text-ink cursor-pointer hover:bg-line-soft"
              >
                {city.name} <span className="text-muted-2">· {city.area}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
      {showEmpty && <p className="mt-2 text-[13px] text-muted">Міст не знайдено.</p>}
    </div>
  );
}
